
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.773 12.125c-1.145 0-1.984-.445-2.515-1.336C.727 9.893.46 8.53.46 6.695c0-1.838.292-3.24.875-4.203.583-.963 1.437-1.445 2.562-1.445 1.141 0 1.987.44 2.54 1.32.552.88.828 2.24.828 4.078 0 1.896-.292 3.318-.875 4.266-.584.943-1.456 1.414-2.618 1.414zM1.898 6.148H5.82c-.073-2.99-.724-4.484-1.953-4.484-1.27 0-1.927 1.495-1.969 4.484zm3.93.797h-3.93c.058 3.037.722 4.555 1.993 4.555 1.27 0 1.916-1.518 1.937-4.555z","fill":"currentColor"}})])
          )
        }
      }
    